/** Which edge the side panel docks to. */
export type PanelSide = 'left' | 'right';

/** One key for every prototype: they share the serve.mjs origin, and a viewer who docks right wants it everywhere. */
const SIDE_STORAGE_KEY = 'prototype-panel-side';

export const SIDE_ATTRIBUTE = 'data-prototype-panel-side';

/** A per-viewer preference, so localStorage and never the shared URL. */
export class PrototypePanelSide {
    public static stored(): PanelSide {
        try {
            return window.localStorage.getItem(SIDE_STORAGE_KEY) === 'right' ? 'right' : 'left';
        } catch {
            return 'left';
        }
    }

    public static store(side: PanelSide) {
        try {
            window.localStorage.setItem(SIDE_STORAGE_KEY, side);
        } catch {
            // Storage blocked (private window, previews): the move still works for this page view.
        }
    }

    public static other(side: string | null): PanelSide {
        return side === 'right' ? 'left' : 'right';
    }
}
